import styled from '@emotion/styled';
import { BreakPointToken } from '../../hooks/useMediaQuery';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

const {
	spacing: {
		size_2px: { height: size_2 },
		size_8px: { height: size_8 },
		size_12px: { height: size_12 },
		size_16px: { height: size_16 }
	},
	color: colours
} = tokens;

export const Row = styled.section`
	width: 100%;
	padding: ${size_12}px 0 0 0;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		padding: ${size_2}px 0 0 0;

		&:last-of-type {
			padding-bottom: ${size_2}px;
		}
	}

	&:last-of-type {
		margin-bottom: ${size_8}px;

		@media (min-width: ${BreakPointToken.MdMin}px) {
			margin-bottom: ${size_2}px;
		}
	}
`;

export const RowInner = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${size_8}px;
	grid-row: 2;
	grid-column: 1 / span 2;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		grid-row: unset;
		grid-column: unset;
		grid-template-columns: repeat(3, 1fr);
		gap: ${size_16}px;
		padding: 0;
	}
`;

export const RowHeading = styled.div`
	margin: 0 0 ${size_8}px;
	display: flex;
	gap: ${size_12}px;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		margin: 0 0 ${size_2}px;
	}
`;

export const RemoveLink = styled.span``;

export const AddRowButton = styled.div<{ $isActive: boolean }>`
	width: 100%;
	transition: opacity 0.3s ease-in-out;
	opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};

	@media (min-width: ${BreakPointToken.MdMin}px) {
		width: auto;
	}
`;
